import script from "./MultasPagoView.vue?vue&type=script&setup=true&lang=js"
export * from "./MultasPagoView.vue?vue&type=script&setup=true&lang=js"

import "./MultasPagoView.vue?vue&type=style&index=0&id=d79ccff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d79ccff0"]])

export default __exports__